import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Modal, message } from "antd";
import server from "../../../server";
import { useBaseComponent } from "../../../base/base-component";
import { IDocumentPreviewState, IDocumentViewModalProps } from "./type/document.types";


const DocumentPreview = (props: IDocumentViewModalProps) => {


    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

    const {state, updateState} = useBaseComponent<IDocumentViewModalProps, IDocumentPreviewState>(props, {
        initialState: () => ({
            loading: true,
            numPages: undefined,
            blobURL: ''
        }),
        onInit: () => onInit()
    })

    async function onInit() {
        if (!props.showPreview) return;

        if (props.document.id) {
            const response = await server.document.download(props.document.id);

            if (response instanceof Blob) {
                const previewUrl = URL.createObjectURL(response);
                updateState('blobURL', previewUrl);
            } else {
                message.error("Failed to download the document!");
            }

            updateState('loading', false);
        }
    }

    const onDocumentLoadSuccess = ({numPages}: any) => {
        updateState('numPages', numPages);
    };

    return (
        state.loading ? <></> :
            <Modal
                open={props.showPreview}
                footer={null}
                className={"hrms-app pn-document__view-modal"}
                onCancel={props.closePreview}
                loading={state.loading}
            >
                {props.document.contentType === 'application/pdf' ?
                    <Document
                        file={state.blobURL}
                        onLoadSuccess={onDocumentLoadSuccess}
                        className="pn-document__view-pdf"
                        loading={<h1 className={'loading-document'}>Loading Document...</h1>}
                    >
                        {Array.from(new Array(state.numPages), (el, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                width={750}
                                renderTextLayer={false}
                            />
                        ))}
                    </Document>
                    :
                    <img
                        src={state.blobURL as string}
                        alt={props.document.name}
                        className="pn-document__view-image"
                    />
                }
            </Modal>
    )
};

export default DocumentPreview;
